/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }, 
  routes: [
    // =============================================================================
    // Theme Routes
    // =============================================================================
    {
      path: '/',
      redirect: '/dashboard'
    },
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
    {
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // 대쉬보드
        // =============================================================================
        // =============================================================================
        // 시스템관리자(sysadmin)
        // =============================================================================
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import('@/views/dashboard/DashboardSysadmin.vue'),
          meta: {
            auth: true,
            //role: 'sysadmin',
            breadcrumb: [
              { title: '대쉬보드', url: '/dashboard' },
              { title: '대쉬보드', active: true }
            ],
            pageTitle: '대쉬보드',
            rule: 'editor'
          }
        },
        // =============================================================================
        // 학원장(instchief)
        // =============================================================================
        {
          path: '/inst/dashboard',
          name: 'dashboard-instchief',
          component: () => import('@/views/dashboard/DashboardInstichief.vue'),
          meta: {
            auth: true,
            role: 'instchief',
            breadcrumb: [
              { title: '대쉬보드', url: '/inst/dashboard' },
              { title: '대쉬보드', active: true }
            ],
            pageTitle: '대쉬보드',
            rule: 'editor'
          }
        },
        // =============================================================================
        // 학원관리
        // =============================================================================
        {
          path: '/institute/institute-list',
          name: 'institute-list',
          component: () => import('@/views/institute/institute-list/InstituteList.vue'),
          meta: { 
            auth: true,
            role: 'sysadmin',
            breadcrumb: [
              { title: '학원관리', url: '/institute/institute-list' },
              { title: '학원관리', active: true }
            ],
            pageTitle: '학원관리',
            rule: 'editor'
          }
        },
        {
          path: '/institute/institute-info',
          name: 'my-institute-info',
          component: () => import('@/views/institute/MyInstituteView.vue'),
          meta: { 
            auth: true,
            breadcrumb: [{ title: '학원정보',  active: true }],
            pageTitle: '학원정보',
            rule: 'instchief'
          }
        },
        {
          path: '/institute/institute-edit/',
          name: 'my-institute-edit',
          component: () => import('@/views/institute/institute-edit/MyInstituteEdit.vue'),
          meta: { 
            auth: true,
            breadcrumb: [{ title: '학원정보수정', active: true }],
            pageTitle: '학원정보 수정',
            rule: 'instchief'
          }
        },
        {
          path: '/institute/institute-view/:instituteSeq',
          name: 'institute-view',
          component: () => import('@/views/institute/InstituteView.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '학원관리', url: '/institute/institute-list' },
              { title: '학원관리'},
              { title: '학원조회', active: true }
            ],
            pageTitle: '학원조회',
            rule: 'editor'
          }
        },
        {
          path: '/institute/institute-add',
          name: 'institute-add',
          component: () => import('@/views/institute/institute-add/InstituteAdd.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '학원관리', url: '/institute/institute-list' },
              { title: '학원관리'},
              { title: '학원추가', active: true }
            ],
            pageTitle: '학원추가',
            rule: 'editor'
          }
        },
        {
          path: '/institute/institute-edit/:instituteSeq',
          name: 'institute-edit',
          component: () => import('@/views/institute/institute-edit/InstituteEdit.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '학원관리', url: '/institute/institute-list' },
              { title: '학원관리'},
              { title: '학원 정보 수정', active: true }
            ],
            pageTitle: '학원 정보 수정',
            rule: 'editor'
          }
        },
        // =============================================================================
        // 교재주문관리-교재관리
        // =============================================================================
        {
          path: '/book/book-list',
          name: 'book-list',
          component: () => import('@/views/book/book-list/BookList.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '교재관리', url: '/book/book-list' },
              { title: '교재관리', active: true }
            ],
            pageTitle: '교재관리',
            rule: 'editor'
          }
        },
        {
          path: '/book/book-view/:bookSeq',
          name: 'book-view',
          component: () => import('@/views/book/BookView.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '교재관리', url: '/book/book-list' },
              { title: '교재조회', active: true }
            ],
            pageTitle: '교재조회',
            rule: 'editor'
          }
        },
        {
          path: '/book/book-add',
          name: 'book-add',
          component: () => import('@/views/book/book-add/BookAdd.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '교재관리', url: '/book/book-list' },
              { title: '교재추가', active: true }
            ],
            pageTitle: '교재추가',
            rule: 'editor'
          }
        },
        {
          path: '/book/book-edit/:bookSeq',
          name: 'book-edit',
          component: () => import('@/views/book/book-edit/BookEdit.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '교재관리', url: '/book/book-list' },
              { title: '교재 정보 수정', active: true }
            ],
            pageTitle: '교재 정보 수정',
            rule: 'editor'
          }
        },
        {
          path: '/book/bookmeta-add/:bookSeq',
          name: 'bookmeta-add',
          component: () => import('@/views/book/book-meta/BookMetaAdd.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '교재관리', url: '/book/book-list' },
              { title: '교재조회'},
              { title: '교재 메타정보 추가', active: true }
            ],
            pageTitle: '교재 메타정보 추가',
            rule: 'editor'
          }
        },
        {
          path: '/book/bookmeta-edit/:bookSeq/:bookMetaSeq',
          name: 'bookmeta-edit',
          component: () => import('@/views/book/book-meta/BookMetaEdit.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '교재관리', url: '/book/book-list' },
              { title: '교재조회'},
              { title: '교재 메타정보 수정', active: true }
            ],
            pageTitle: '교재 메타정보 수정',
            rule: 'editor'
          }
        },
        {
          path: '/book/book-contents/:bookSeq',
          name: 'book-contents',
          component: () => import('@/views/contents/ContentList.vue'),
          //component: () => import('@/views/book/book-contents/BookContents.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '교재관리', url: '/book/book-list' },
              { title: '교재조회'},
              { title: '컨텐츠 관리', active: true }
            ],
            pageTitle: '컨텐츠 관리',
            rule: 'editor'
          }
        },
        // =============================================================================
        // 교재주문관리-교재주문
        // =============================================================================
        {
          path: '/order/product-list',
          name: 'product-list',
          component: () => import('@/views/order/product-list/ProductList.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '교재주문', url: '/book/order/product-list' },
              { title: '교재주문', active: true }
            ],
            pageTitle: '교재주문',
            rule: 'editor'
          }
        },
        {
          path: '/order/basket-list',
          name: 'basket-list',
          component: () => import('@/views/order/basket-list/BasketList.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '교재주문', url: '/order/basket-list' },
              { title: '교재주문'},
              { title: '장바구니', active: true }
            ],
            pageTitle: '장바구니',
            rule: 'editor'
          }
        },
        
        // =============================================================================
        // 교재주문관리 - 교재주문현황
        // =============================================================================
        {
          path: '/ordersheet/ordersheet-list',
          name: 'ordersheet-list',
          component: () => import('@/views/ordersheet/ordersheet-list/OrderSheetList.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '교재주문현황', url: '/ordersheet/ordersheet-list' },
              { title: '교재주문현황', active: true }
            ],
            pageTitle: '교재주문현황',
            rule: 'editor'
          }
        },
        {
          path: '/ordersheet/ordersheet-view/:orderSheetSeq',
          name: 'ordersheet-view',
          component: () => import('@/views/ordersheet/OrderSheetView.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '교재주문현황', url: '/ordersheet/ordersheet-list' },
              { title: '교재주문현황', active: true }
            ],
            pageTitle: '교재주문 조회',
            rule: 'editor'
          }
        },
        // =============================================================================
        // 회원관리 
        // =============================================================================   
        {
          path: '/member/member-list',
          name: 'member-list',
          component: () => import('@/views/member/member-list/MemberList.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '회원관리', url: '/member/member-list' },
              { title: '회원관리', active: true }
            ],
            pageTitle: '회원관리',
            rule: 'editor'
          }
        },
        {
          path: '/member/member-view/:userID',
          name: 'member-view',
          component: () => import('@/views/member/MemberView.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '회원관리', url: '/member/member-list' },
              { title: '회원관리'},
              { title: '회원조회', active: true }
            ],
            pageTitle: '회원조회',
            rule: 'editor'
          }
        },
        {
          path: '/member/member-add',
          name: 'member-add',
          component: () => import('@/views/member/member-add/MemberAdd.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '회원관리', url: '/member/member-list' },
              { title: '회원관리'},
              { title: '회원추가', active: true }
            ],
            pageTitle: '회원추가',
            rule: 'editor'
          }
        },
        {
          path: '/member/member-edit/:userID',
          name: 'member-edit',
          component: () => import('@/views/member/member-edit/MemberEdit.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '회원관리', url: '/member/member-list' },
              { title: '회원관리'},
              { title: '회원 정보 수정', active: true }
            ],
            pageTitle: '회원 정보 수정',
            rule: 'editor'
          }
        },
        // =============================================================================
        // 학생관리 
        // =============================================================================   
        {
          path: '/student/student-list',
          name: 'student-list',
          component: () => import('@/views/student/student-list/StudentList.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '학생관리', url: '/student/student-list' },
              { title: '학생관리', active: true }
            ],
            pageTitle: '학생관리',
            rule: 'editor'
          }
        },
        {
          path: '/student/student-view/:studentID',
          name: 'student-view',
          component: () => import('@/views/student/StudentView.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '학생관리', url: '/student/student-list' },
              { title: '학생관리'},
              { title: '학생조회', active: true }
            ],
            pageTitle: '학생조회',
            rule: 'editor'
          }
        },
        {
          path: '/student/student-edit/:studentID',
          name: 'student-edit',
          component: () => import('@/views/student/student-edit/StudentEdit.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '학생관리', url: '/student/student-list' },
              { title: '학생관리'},
              { title: '학생 정보 수정', active: true }
            ],
            pageTitle: '학생 정보 수정',
            rule: 'editor'
          }
        },
        {
          path: '/student/book-add/:studentID',
          name: 'student-book-add',
          component: () => import('@/views/student/book-add/BookAdd.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '학생관리', url: '/student/student-list' },
              { title: '학생관리'},
              { title: '수업관리'},
              { title: '학습설계', active: true }
            ],
            pageTitle: '학습설계',
            rule: 'editor'
          }
        },
        // =============================================================================
        // 교직원관리 
        // =============================================================================   
        {
          path: '/teacher/teacher-list',
          name: 'teacher-list',
          component: () => import('@/views/teacher/teacher-list/TeacherList.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '교직원관리', url: '/teacher/teacher-list' },
              { title: '교직원관리', active: true }
            ],
            pageTitle: '교직원관리',
            rule: 'editor'
          }
        },
        {
          path: '/teacher/teacher-view/:teacherID',
          name: 'teacher-view',
          component: () => import('@/views/teacher/TeacherView.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '교직원관리', url: '/teacher/teacher-list' },
              { title: '교직원관리'},
              { title: '교직원조회', active: true }
            ],
            pageTitle: '교직원조회',
            rule: 'editor'
          }
        },
        {
          path: '/teacher/teacher-edit/:teacherID',
          name: 'teacher-edit',
          component: () => import('@/views/teacher/teacher-edit/TeacherEdit.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '교직원관리', url: '/teacher/teacher-list' },
              { title: '교직원관리'},
              { title: '교직원 정보 수정', active: true }
            ],
            pageTitle: '교직원 정보 수정',
            rule: 'editor'
          }
        },
        // =============================================================================
        // 공지사항
        // =============================================================================
        {
          path: '/board/board-list',
          name: 'board-list',
          component: () => import('@/views/board/board-list/BoardList.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '공지사항', url: '/board/board-list' },
              { title: '공지사항', active: true }
            ],
            pageTitle: '공지사항',
            rule: 'editor'
          }
        },
        {
          path: '/board/board-view/:boardEntrySeq',
          name: 'board-view',
          component: () => import('@/views/board/BoardView.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '공지사항', url: '/board/board-list' },
              { title: '공지사항'},
              { title: '공지사항 조회', active: true }
            ],
            pageTitle: '공지사항 조회',
            rule: 'editor'
          }
        },
        {
          path: '/board/board-add',
          name: 'board-add',
          component: () => import('@/views/board/board-add/BoardAdd.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '공지사항', url: '/board/board-list' },
              { title: '공지사항'},
              { title: '공지사항 추가', active: true }
            ],
            pageTitle: '공지사항 추가',
            rule: 'editor'
          }
        },
        {
          path: '/board/board-edit/:boardEntrySeq',
          name: 'board-edit',
          component: () => import('@/views/board/board-edit/BoardEdit.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '공지사항', url: '/board/board-list' },
              { title: '공지사항'},
              { title: '공지사항 수정', active: true }
            ],
            pageTitle: '공지사항 수정',
            rule: 'editor'
          }
        },
        
        // =============================================================================
        // 자료실
        // =============================================================================
        {
          path: '/archive/archive-list',
          name: 'archive-list',
          component: () => import('@/views/archive/archive-list/ArchiveList.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '자료실', url: '/archive/archive-list' },
              { title: '자료실', active: true }
            ],
            pageTitle: '자료실',
            rule: 'editor'
          }
        },
        {
          path: '/archive/archive-view/:boardEntrySeq',
          name: 'archive-view',
          component: () => import('@/views/archive/ArchiveView.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '자료실', url: '/archive/archive-list' },
              { title: '자료실'},
              { title: '자료실 조회', active: true }
            ],
            pageTitle: '자료실 조회',
            rule: 'editor'
          }
        },
        {
          path: '/archive/archive-add',
          name: 'archive-add',
          component: () => import('@/views/archive/archive-add/ArchiveAdd.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '자료실', url: '/archive/archive-list' },
              { title: '자료실'},
              { title: '자료 추가', active: true }
            ],
            pageTitle: '자료 추가',
            rule: 'editor'
          }
        },
        {
          path: '/archive/archive-edit/:boardEntrySeq',
          name: 'archive-edit',
          component: () => import('@/views/archive/archive-edit/ArchiveEdit.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '자료실', url: '/archive/archive-list' },
              { title: '자료실'},
              { title: '자료실 수정', active: true }
            ],
            pageTitle: '자료실 수정',
            rule: 'editor'
          }
        },
        {
          path: '/content/content-list',
          name: 'content-list',
          component: () => import('@/views/contents/ContentList.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '컨텐츠 관리', url: '/content/content-list' },
              { title: '컨텐츠 조회', active: true }
            ],
            pageTitle: '컨텐츠 관리',
            rule: 'editor'
          }
        },
        {
          path: '/content/content-add',
          name: 'content-add',
          component: () => import('@/views/contents/ContentAdd.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '컨텐츠 관리', url: '/content/content-list' },
              { title: '컨텐츠 추가', active: true }
            ],
            pageTitle: '컨텐츠 추가',
            rule: 'editor'
          }
        },
        {
          path: '/content/content-edit/:studyContentSeq',
          name: 'content-edit',
          component: () => import('@/views/contents/ContentEdit.vue'),
          meta: { 
            auth: true,
            breadcrumb: [
              { title: '컨텐츠 관리', url: '/content/content-list' },
              { title: '컨텐츠 수정', active: true }
            ],
            pageTitle: '컨텐츠 수정',
            rule: 'editor'
          }
        },
        {
          path: '/code',
          name: 'code',
          component: () => import('@/views/code/CodeList.vue'),
          meta: { 
            auth: true,
            breadcrumb: [{ title: '코드 관리', active: true}],
            pageTitle: '코드 관리',
            rule: 'editor'
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('./layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES 
        // =============================================================================  
        {
          path: '/login', 
          name: 'login',
          component: () => import('@/views/auth/Login.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/error-404', 
          name: 'error-404',
          component: () => import('@/views/error/Error404.vue'),
          meta: {
          }
        },
        {
          path: '/error-500',
          name: 'error-500',
          component: () => import('@/views/error/Error500.vue'),
          meta: {
          }
        },
        {
          path: '/error-401',
          name: 'error-401',
          component: () => import('@/views/error/NotAuthorized.vue'),
          meta: {
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/error-404'
    }
  ]
})

router.beforeEach((to, from, next) => {
  
  //console.log(to.meta.rule)

  if (to.meta.auth && !store.getters.isLogin) {
    console.log('인증이 필요합니다.')
    next('/login')
    return
  } 

  // if (to.path === '/dashboard') {
  //   const role = store.getters.getUserInfo.userType
  //   if (role === 'sysadmin') {
  //     next('/admin/dashboard')
  //   } else if (role === 'instchief') {
  //     next('/inst/dashboard')
  //   }
  //   return
  // }

  next()
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
